export const SUBMIT_ANALYTICS_BY_MONTH_ACTION_REQUESTED = "SUBMIT_ANALYTICS_BY_MONTH_ACTION_REQUESTED";
export const SUBMIT_ANALYTICS_BY_MONTH_ACTION_DISPATCHER = "SUBMIT_ANALYTICS_BY_MONTH_ACTION_DISPATCHER";
export const SUBMIT_ANALYTICS_BY_MONTH_ERROR_DISPATCHER = "SUBMIT_ANALYTICS_BY_MONTH_ERROR_DISPATCHER";
export const ANALYTICS_BY_MONTH_LOADING = "ANALYTICS_BY_MONTH_LOADING";

//Action Creator
export const submitAnalyticsByMonthAction = (data) => ({
  type: SUBMIT_ANALYTICS_BY_MONTH_ACTION_REQUESTED,
  postData: data,
});

//Action Dispatcher
export const submitAnalyticsByMonthActionDispatcher = (data) => ({
  type: SUBMIT_ANALYTICS_BY_MONTH_ACTION_DISPATCHER,
  payload: data,
});

export const submitAnalyticsByMonthErrorDispatcher = (data) => ({
  type: SUBMIT_ANALYTICS_BY_MONTH_ERROR_DISPATCHER,
  payload: data,
});

export const analyticsByMonthLoading = (loading) => ({
  type: ANALYTICS_BY_MONTH_LOADING,
  payload: loading,
});

